import type { ComponentProps } from 'react';
import { PriceChip, Skeleton, Typography } from 'ui';

type Props = {
  isLoading?: boolean;
  guidePrice?: string;
} & Omit<ComponentProps<typeof PriceChip>, 'children'>;

export const GuidePriceChip = ({ guidePrice, isLoading, ...rest }: Props) => {
  if (isLoading) {
    return <Skeleton data-testid="guide-price-loader" variant="rounded" width="100%" height={50} />;
  }

  if (!guidePrice) {
    return (
      <PriceChip {...rest}>
        <Typography data-testid="guide-price-unavailable" variant="caption" color="textSecondary" display="block">
          Guide price unavailable
        </Typography>
      </PriceChip>
    );
  }
  return (
    <PriceChip {...rest}>
      <Typography variant="inherit" whiteSpace="nowrap" component="span" display="block">
        {guidePrice}
      </Typography>
      <Typography variant="caption" color="textSecondary" display="block">
        Guide price
      </Typography>
    </PriceChip>
  );
};
